import { CommonFilterTerms, CommonSortTerms } from "consts";

/**
 *
 * @param filterOverrides {Object}
 * @param sortOverrides {Object}
 * @returns {{sortTerms: {NEWEST_UPDATE: string, OLDEST_UPDATE: string},
 *  filterTerms: {ORDER_ASC: string, ORDER_DESC: string, NONE: string}}}
 */
const buildCommonSearchFilters = (filterOverrides = {}, sortOverrides = {}) => {
  return {
    filterTerms: Object.assign({}, CommonFilterTerms, filterOverrides),
    sortTerms: Object.assign({}, CommonSortTerms, sortOverrides),
  };
};

export default buildCommonSearchFilters;
